import { render } from "./ConfigurationsTable.vue?vue&type=template&id=7447f43c&scoped=true"
import script from "./ConfigurationsTable.vue?vue&type=script&lang=js"
export * from "./ConfigurationsTable.vue?vue&type=script&lang=js"

import "./ConfigurationsTable.vue?vue&type=style&index=0&id=7447f43c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7447f43c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCheckbox});
